class Controller {
  constructor($mdDialog, $injector, admin) {
    "ngInject";

    this.$injector = $injector;
    this.$mdDialog = $mdDialog;
    this.admin = admin;
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    this.$mdDialog.hide();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporate/resetPasswordDialog/resetPasswordDialog.controller.js